import React, { Component } from 'react'
import AuthService from "../../services/AuthService";
import '../../css/BisharatMain.css';
import Form from "react-validation/build/form";
import Input from "react-validation/build/input";
import CheckButton from "react-validation/build/button";
import translate from '../../languages/translate';


export default class ModifyNumberSMSVerify extends Component {
    constructor(props) {
        super(props);
        this.handleVerify = this.handleVerify.bind(this);
        this.onChangeToken = this.onChangeToken.bind(this);

  this.state = {
    oneUser: [],
    token: "",
    userName:"",
    verifytryCN : localStorage.getItem("verifytryCN"),
    activatedSuccessfully : false,
    loading: false,
    message : ""
  };
    }

  onChangeToken(e) {
    this.setState({
        token: e.target.value
    });
  }


  handleVerify(e) {
    e.preventDefault();

    this.setState({
      message: "",
      loading: true
    });

    this.form.validateAll();

    if (this.checkBtn.context._errors.length === 0) {
      const tryverifyCN = localStorage.getItem("verifytryCN");
      if(tryverifyCN <= 1 ) {
        localStorage.setItem("user",null) ;
        window.location.href = '/';
      } else {
      localStorage.setItem("verifytryCN",tryverifyCN -1);
      AuthService.modifynumberconfirmation(
        this.state.username,
        this.state.token,
        this.state.newNumber
      ).then(
        response => {
          this.setState({
            activatedSuccessfully : true,
            message: response.data.message,
            successful: true
          });
          localStorage.setItem("user",null);
          window.setTimeout(function() { window.location.href = `/profile`;}, 5000);
          
        },
        error => {
          const resMessage =
            (error.response &&
              error.response.data &&
              error.response.data.message) ||
            error.message ||
            error.toString();

          this.setState({
            successful: false,
            message: resMessage,
            activatedSuccessfully: false
          });
          window.location.reload();
        }
      );
    }} else {
   
      this.setState({
        loading: false
      }); 
    }
  }






  componentDidMount() {
    this.refreshActiveSMSPage();
  }





  refreshActiveSMSPage = ()  => {
    const { match: { params } } = this.props;
        const userName = params.username;
        const newNumber = params.newNumber;
             this.setState({username : userName , newNumber: newNumber}
            );   
    }
 
  

  render() {

    const required = value => {
      if (!value) {
        return (
          <div className="alertDanger" >
               <p className="alertDanger">  
         {translate("mandatory")}         
          </p> 
          </div>
        );
      }
    };


    return (
 <div className="activate-user-wrap">
<div className="button-activate-user1">

<div className="register-not-signed">
   
   <Form
     onSubmit={this.handleVerify}
     ref={c => {
       this.form = c;
     }}
   >
     {!this.state.successful && (
       <div>
         <div className="form-group">
           <label htmlFor="token">{translate("code")}</label>
           <Input
             type="text"
             className="form-control-mod"
             name="token"
             value={this.state.token}
             onChange={this.onChangeToken}
             validations={[required]}
           />
         </div>
         <div className="form-group">
         {/* <button  onClick={() => this.activateUserNow( this.state.username,this.state.token)}>  </button> */}
         <button
                className="btn"
                disabled={this.state.loading}
              >
                {this.state.loading && (
                  <span className="spinner-border spinner-border-sm"></span>
                )}
{translate("verify-code")
}              </button>
         </div>
         </div>
            )}
     {this.state.message && (
              <div className="form-group">
                <div
                  className={
                    this.state.successful
                      ? "alertSuccess" 
                      : "alertDanger"
                  }
                  role="alert"
                >
                  
                  {this.state.message === 'Phone number changed successfully! ' && translate("number-changed-successfully")}
                  
                </div>
              </div>
            )}
            <CheckButton
              style={{ display: "none" }}
              ref={c => {
                this.checkBtn = c;
              }}
            />
          </Form>
          {!this.state.successful && localStorage.getItem("verifytryCN") > 0 ?
          <div>
          <p className="alertDanger">{translate("youve")} {localStorage.getItem("verifytryCN")} {translate("tries")}  </p>
          </div>
         : <>
         
         {localStorage.setItem("user",null)} 
         { <a href="/" className="btn"> {translate("back")}  </a> }
         </>
          }


          {/* <button className="btn" onClick={this.props.history.goBack}> للعودة  </button> */}
          </div>
 
</div>

    </div>
    )
  }
}
